function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  stroke: "#97979D",
  cx: 15,
  cy: 15,
  r: 14.5
}), React.createElement("path", {
  d: "M18.793 11.632c.51-.322.902-.833 1.086-1.441a4.792 4.792 0 0 1-1.57.632A2.406 2.406 0 0 0 16.507 10c-1.365 0-2.47 1.167-2.47 2.606 0 .204.02.404.063.594-2.054-.11-3.874-1.146-5.094-2.724a2.71 2.71 0 0 0-.334 1.311c0 .904.436 1.702 1.1 2.17a2.383 2.383 0 0 1-1.12-.326v.033c0 1.263.85 2.316 1.982 2.555a2.324 2.324 0 0 1-1.116.045c.314 1.035 1.227 1.79 2.308 1.81a4.797 4.797 0 0 1-3.658 1.08 6.738 6.738 0 0 0 3.788 1.17c4.546 0 7.03-3.97 7.03-7.415 0-.113-.001-.226-.006-.337a5.166 5.166 0 0 0 1.233-1.35c-.443.207-.92.348-1.419.41z",
  fill: "#97979D"
}));

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 30,
    height: 30,
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.dd9457c8.svg";
export { ForwardRef as ReactComponent };